var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessSnackbarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 6,
    fill: "#17B31B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6506 9.3173C19.0737 8.89423 19.7596 8.89423 20.1827 9.3173C20.5732 9.70783 20.6033 10.3223 20.2728 10.7473L20.1827 10.8494L12.7348 18.2973C12.3443 18.6878 11.7298 18.7178 11.3048 18.3874L11.2027 18.2973L7.8173 14.9119C7.39423 14.4888 7.39423 13.8029 7.8173 13.3798C8.20783 12.9893 8.82233 12.9592 9.24731 13.2897L9.34937 13.3798L11.9688 15.9983L18.6506 9.3173Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessSnackbarIcon);
export default __webpack_public_path__ + "static/media/success-snackbar-icon.2595dbc7367f01ef078abc779bbb53dd.svg";
export { ForwardRef as ReactComponent };